import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import Main_Winter from '../../component/Winter/Main_Winter';
import Save_Date_Fall from '../../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../../component/Fall/Info_Fall';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import AccountList2 from '../../component/Account/AccountList2';
import CallInfo from '../../component/CallInfo';
import musicTitle from '../../asset/music/beauty.mp3'
import Information from '../../component/Information';

const SeoYeKyo = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "손인배♥서예교 결혼합니다.";
    const openDesc = "더파티움 여의도 8월 9일 오후 2시 50분";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/247/thumb1.jpg";
    
    const placeTelNum = "02-784-0000";

    const lng = 126.9225145;
    const lat = 37.5281286;

    const forShuttleBus = "5호선 여의나루역 1번 출구 (셔틀버스 수시 운행)"
    const forSubway = "[도보] 9호선 국회의사당역 3번 출구 (도보 5분)\n[셔틀] 5호선 여의나루역 1번 출구 (셔틀버스 수시 운행)\n[버스] 5호선 여의나루역 2번 출구 (10번 승차 후 \n            ‘기계회관’ 하차)"
    const forCar = "네비게이션 '더파티움 여의도' \n서울 영등포구 은행로 30, 중소기업중앙회"
    const forParking = "더파티움 여의도 지하 주차장 \n주차 90분 무료, B1 연회장 입구 주차 등록"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        concept: "WINTER",
        titleColor: "#000000",
        pointColor: "#000000",
        btnBgColor: "#000000",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F4F4F4",
        fontFamilyKo: "JejuMyeongjo",
        fontFamilyEn: "Milchella"
    }


    const parents = [
        {groom : "진용성 · 서윤희의 장남"},
        {bride : "박광익 · 장남옥의 차녀"}
    ]

    const title = "13년 연애 끝, 우리 결혼합니다.";
    const msg1 = "열일곱 서로의 첫사랑으로 만나\n이제는 영원한 사랑을 약속하려 합니다."
    const msg2 = "시간이 흘러도 변함없는 마음으로 \n평생을 함께하겠습니다."
    const msg3 = "오래도록 다정한 사랑으로 걸어가는 길에\n축복의 걸음으로 함께해 주신다면 감사하겠습니다.\n\n"


    const groomAccountList = [
        {
            role: "신랑",
            name: "손인배",
            bank: "우리은행",
            accountNumber : "1002-047-715848",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FIctbTs5T"
        }
        ,{
            role: "신랑 부",
            name: "손종진",
            bank: "농협은행",
            accountNumber : "100032-56-011998",
            isKakao : false
        },
        {
            role: "신랑 모",
            name: "선태순",
            bank: "국민은행",
            accountNumber : "487125-01-070204",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "서예교",
            bank: "카카오뱅크",
            accountNumber : "3333-14-2721145",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej7n0WHHq"
        }
        ,{
            role: "신부 부",
            name: "서정광",
            bank: "국민은행",
            accountNumber : "408801-01-281708",
            isKakao : false
        }
        // ,{
        //     role: "신부 모",
        //     name: "최은주",
        //     bank: "농협은행",
        //     accountNumber : "585-02-266507",
        //     isKakao : false
        // }
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "정우진",
            call: "010-5467-5127"
        }
        ,
        {
            role: "신랑 부",
            name: "정창호",
            call: "010-3867-5127"
        },
        {
            role: "신랑 모",
            name: "김복경",
            call: "010-2425-3349"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "안현주",
            call: "010-2490-9377"
        }
        ,{
            role: "신부 부",
            name: "안인성",
            call: "010-2324-9377"
        }
        ,{
            role: "신부 모",
            name: "김미정",
            call: "010-7935-9377"
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "시간이 흘러도 바뀌지 않을 건?",
            groomAnswer: "옆에있을나",
            brideAnswer: "꼭잡은두손"
        },
        {
            question : "함께한 시간, 어떻게 기억해?",
            groomAnswer: "평생의추억",
            brideAnswer: "선물이었어"
        },
        {
            question : "나는 너에게 어떤 존재야?",
            groomAnswer: "나의매순간",
            brideAnswer: "내삶의전부"
        },
        {
            question : "오래 함께한 우리, 지금 어떤 기분이야?",
            groomAnswer: "설렘과행복",
            brideAnswer: "꿈결같은걸"
        },
        {
            question : "결혼을 앞두고, 서로에게 약속하고 싶은 것은?",
            groomAnswer: "변함없을게",
            brideAnswer: "영원한네편♥"
        }
    ]

    const informationList =[
        {
            title : "화환 안내",
            content : "화환은 정중히 사양하오니 \n너른 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#000000"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Winter width={"300px"} weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstNameEn(weddingData.brideNameEn)} groomNameEn={getFirstNameEn(weddingData.groomNameEn)} />
                    <Save_Date_Fall weddingData={weddingData} color={conceptStyle.titleColor} />
                    <Info_Fall conceptStyle={conceptStyle} weddingData={weddingData} />
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    {/* <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.brideName)} brideName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Location_Spring  weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                        <Location_Desc forShuttleBus={forShuttleBus} forSubway={forSubway} forParking={forParking} forCar={forCar} conceptStyle={conceptStyle}/>
                        <Information conceptStyle={conceptStyle} informationList={informationList} />
                        <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                        <Footer />
                </>
            )}
        </div>
    );
    
};

export default SeoYeKyo;